<!--
 * @Description: 素材库/同步至渠道素材
 * @Author: hasayake
 * @Date: 2020-06-16 17:22:50
 * @LastEditTime: 2020-06-16 17:43:32
 * @LastEditors: Please set LastEditors
-->

<template>
  <el-dialog
    title="同步至渠道素材库"
    :visible.sync="value"
    width="512px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="sync-channel-material">
      <div>
        <h4>选择账户</h4>
        <el-select style="width: 100%;" size="small" v-model="selectVal">
          <el-option
            v-for="item in selectList"
            :key="item.actId"
            :label="item.actName"
            :value="item.actId"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <h4>请确认客户是否已经审核素材，若审核通过，请提交证明截图</h4>
        <!-- <el-button type="primary" size="small" class="input-upload">
          上传文件
          <input type="file" multiple @change="fileChangeHandler" />
        </el-button> -->
        <el-upload
          class="prove-uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleChange"
        >
          <img v-if="imageUrl" :src="imageUrl" class="prove" />
          <i v-else class="el-icon-plus prove-uploader-icon"></i>
        </el-upload>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onsubmit" :disabled="sbmDisableb"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { materialLibrarysHandler } from "@/assets/js/api";

export default {
  name: "syncToChannelMaterial",

  props: {
    value: {
      type: Boolean,
      default: false
    },

    projectId: {
      type: String,
      default: ""
    },

    platform: {
      type: Number,
      default: 0
    },

    checkedList: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      selectList: [],
      selectVal: "",
      imageUrl: "",
      file: null,
      loading:false
    };
  },

  methods: {
    handleClose() {
      this.$emit("input", false);
      
    },
    getAccountList() {
      if (this.projectId === "") return;

      materialLibrarysHandler
        .getAccount({
          projectId: this.projectId,
          platform: this.platform
        })
        .then(res => {
          this.selectList = res.data;
        });
    },
    fileChangeHandler(e) {},
    handleChange(file) {
      this.file = file.raw;
      this.imageUrl = this.getFileUrl(file.raw);
    },
    getFileUrl(obj) {
      return window.URL.createObjectURL(obj);
    },
    onsubmit() {
      this.loading = true
      const docId = this.checkedList.map(item => item.fileId);
      const docIdStr = docId.join()
      let param = new FormData();
      param.append("file", this.file);
      param.append("docIds", docIdStr);
      param.append("actId", this.selectVal);
      param.append("platform", this.platform);
      param.append("projectId",this.projectId)
      materialLibrarysHandler.toChannel(param).then(res => {
        this.$message.success(res.msg);
        this.$emit("refresh");
        this.handleClose()
        this.imageUrl = ""
        this.selectVal=""
        this.loading = false
      });
    }
  },

  mounted() {},
  watch: {
    projectId(val) {
      this.getAccountList();
    }
  },
  computed: {
    sbmDisableb() {
      return !(this.selectVal && this.imageUrl);
    }
  }
};
</script>

<style>
.prove-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.prove-uploader .el-upload:hover {
  border-color: #409eff;
}
.prove-uploader .prove-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.prove {
  width: 140px;
  height: 140px;
  display: block;
}
</style>
